import React from "react";
import OtpInput from "react-otp-input";

const InfoOTP = ({ otpNumber }) => {
  return (
    <div className="w-full p-4 bg-white shadow-md rounded-lg">
      <div className="flex justify-between items-center border-b pb-2">
        <h2 className="text-lg font-semibold  text-gray-800">Start Trip OTP</h2>
      </div>

      <div className="p-4">
        <div className="w-3/5 mt-2">
          <p className="text-sm  text-gray-600">
          Share this OTP with the driver to begin the ride.
          </p>
        </div>

        <div className="flex justify-left w-2/5">
          {otpNumber && (
            <OtpInput
              value={otpNumber}
              numInputs={4}
              isDisabled={true}
              renderInput={(props) => <input {...props} />}
              inputStyle={{
                width: "2.5rem",
                height: "2.5rem",
                fontSize: "1.25rem",
                fontWeight: "bold",
                border: "1px solid #D1D5DB",
                borderRadius: "0.375rem",
                textAlign: "center",
              }}
              containerStyle={{ display: "flex", gap: "0.5rem" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(InfoOTP);
